import { QUOTE_STATUSES } from '../utils/quoteStatus.js';

interface Props {
  status: string;
  showIcon?: boolean;
  size?: 'sm' | 'md';
}

export function QuoteStatusBadge({ status, showIcon = true, size = 'sm' }: Props) {
  const config = QUOTE_STATUSES[status as keyof typeof QUOTE_STATUSES];
  if (!config) return <span className="text-xs text-gray-500">{status}</span>;

  const Icon = config.icon;
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${config.badgeClass} ${sizeClass}`}
    >
      {showIcon && <Icon className={`h-3 w-3 ${config.iconClass}`} />}
      {config.label}
    </span>
  );
}
